import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./layouts.css";
import RequestQuote from "../Modals/RequestQuote";
import { Twirl as Hamburger } from "hamburger-react";
import { API_BASE_URL } from "../../config";
import MegaMenu from "./MegaMenu";
import useAppData from "../../hooks/useAppData";

export default function Header() {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isMobileView, setIsMobileView] = useState(false);
	const [showDropdown, setShowDropdown] = useState(false);
	const [modalShow, setModalShow] = useState(false);
	const {categories, settings} = useAppData();

	const location = useLocation();

	const timeoutRef = useRef(null);

	const handleMouseEnter = () => {
		// cancel any pending close
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
		setShowDropdown(true);
	};

	const handleMouseLeave = () => {
		// start a delayed close (e.g. 300ms)
		timeoutRef.current = setTimeout(() => {
			setShowDropdown(false);
		}, 300);
	};

	const checkMobileView = () => {
		setIsMobileView(window.innerWidth <= 992); // 992px is typical tablet breakpoint
	};

	useEffect(() => {
		checkMobileView();
		window.addEventListener("resize", checkMobileView);
		return () => window.removeEventListener("resize", checkMobileView);
	}, []);

	useEffect(() => {
		// Close mobile menu when route changes
		setIsMobileMenuOpen(false);
	}, [location]);

	return (
		<nav>
			<div className="navbar container d-flex justify-content-between align-items-center px-3">
				<div className="logo-container">
					{isMobileView && (
						<>
							<Hamburger
								toggled={isMobileMenuOpen}
								toggle={setIsMobileMenuOpen}
							/>
						</>
					)}
					<Link to="/">
						<img
							className="logo"
							src={settings?.logo_header && API_BASE_URL + settings.logo_header}
							alt={settings?.website_title || "LOGO"}
						/>
					</Link>
				</div>

				{/* Desktop Navigation - visible on PC */}
				{!isMobileView && (
					<div className="desktop-nav d-flex align-items-center">
						<div className="d-flex nav-items">
							<Link
								className={`${
									location.pathname === "/" ? "active" : ""
								} nav-item text-black text-decoration-none`}
								to={`/`}
							>
								Home
							</Link>
							<Link
								className={`${
									location.pathname === "/about-us" ? "active" : ""
								} nav-item text-black text-decoration-none`}
								to={`/about-us`}
							>
								About Us
							</Link>
							<Link
								className={`${
									location.pathname === "/services" ? "active" : ""
								} ${
									showDropdown ? "opened" : ""
								} nav-item nav-item_services text-black text-decoration-none`}
								onMouseEnter={handleMouseEnter}
								onMouseLeave={handleMouseLeave}
								style={{ position: "relative" }}
								to={`/services`}
							>
								Services
							</Link>
							<Link
								className={`${
									location.pathname === "/contact-us" ? "active" : ""
								} nav-item text-black text-decoration-none`}
								to={`/contact-us`}
							>
								Contact Us
							</Link>
						</div>
						<div className="d-flex">
							<Link
								style={{ background: "#606061" }}
								className="text-white rounded text-decoration-none px-4 py-2"
								onClick={() => setModalShow(true)}
							>
								Request a quote
							</Link>
						</div>

						<div></div>
					</div>
				)}

				{/* Mobile Hamburger Icon - visible only on mobile/tablet */}
				{isMobileView && (
					<>
						<Link
							style={{ background: "#606061" }}
							className="text-white rounded text-decoration-none px-4 py-2"
							onClick={() => setModalShow(true)}
						>
							Request a quote
						</Link>
					</>
				)}
			</div>
			{isMobileView && isMobileMenuOpen && (
				<div className="mobile-nav-overlay">
					<div className="mobile-nav-sidebar">
						<div className="mobile-nav-content">
							<Link
								className="nav-item text-black text-decoration-none px-2"
								to={`/`}
							>
								Home
							</Link>
							<Link
								className="nav-item text-black text-decoration-none px-2"
								to={`/about-us`}
							>
								About Us
							</Link>
							<Link
								className="nav-item text-black text-decoration-none px-2"
								to={`/services`}
							>
								Services
							</Link>
							<Link
								className="nav-item text-black text-decoration-none px-2"
								to={`/contact-us`}
							>
								Contact Us
							</Link>
						</div>
					</div>
				</div>
			)}
			{/* {servicesDropdown} */}
			{showDropdown && (
				<MegaMenu
					setShowDropdown={setShowDropdown}
					categories={categories}
					handleMouseEnter={handleMouseEnter}
					handleMouseLeave={handleMouseLeave}
				/>
			)}
			<RequestQuote show={modalShow} onHide={() => setModalShow(false)} />
		</nav>
	);
}
